<template>
  <div>
    <el-form>
      <el-form-item>
        运单编号:<el-input v-model="to_orderNumber" style="width: 200px;margin-bottom: 20px"></el-input><br>
        客 户 号:<el-input v-model="to_account" style="width: 200px"></el-input>
<!--        <p  v-model="to_orderNumber">{{"运单编号:    " +this.to_orderNumber}}</p>-->
<!--        <p v-model="to_account" >{{"客 户 号:   "+this.to_account}}</p>-->
      </el-form-item>
<!--      <el-form-item>-->
<!--        物品图片-->
<!--        <upload_picture style="width:30%" :img-src="to_picture" @value="uploadData">{{this.to_picture}}</upload_picture>-->
<!--      </el-form-item>-->
      <el-form-item>
        订单状态
        <el-select class="form-control" style="width: 200px ;margin-right: 20px" v-model="to_state">
          <el-option  v-for="item in options" :key="item.value" :label="item.label" :value="item.value"  >{{item.label,item.value}}</el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        备注
        <textarea style="width: 300px;height: 100px" v-model="to_remark"></textarea>
      </el-form-item>
      <el-form-item>
        下单时间：<el-date-picker
        v-model="to_date"
        type="date"
        @change="getStartDate()"
        format="yyyy-MM-dd"
        placeholder="选择日期"
      ></el-date-picker>
      </el-form-item>
      <el-button @click="updateOrder">保存</el-button>
      <el-button @click="back">返回</el-button>
    </el-form>
  </div>
</template>

<script>
  import upload_picture from "../../../components/upload/upload_picture";
  export default {
    components: {
      upload_picture
    },
    data() {
      return {
        options:[
          // {label:'请选择',value:null},
          {label:'未发货',value:0},
          {label:'已发货',value:1},
          {label:'已收货',value:2}
        ],
        to_orderNumber:'',
        to_account:'',
        to_picture:'',
        to_state:'',
        to_remark:'',
        state:'',
        to_date:null,
      }
    },
    mounted() {
      this.to_orderNumber = this.$route.query.to_orderNumber
      this.to_id = this.$route.query.to_id
      this.to_account = this.$route.query.to_account
      this.to_picture = this.$route.query.to_picture
      this.to_remark = this.$route.query.to_remark
      this.to_state=this.$route.query.to_state
      this.to_date=this.$route.query.to_date
      if(this.to_state==0){
        this.to_state='未发货'
      }else if(this.state==1){
        this.to_state='已发货'
      }else{
        this.to_state='已收货'
      }
    },
    methods: {
      //获取开始时间
      getStartDate() {
        const d = new Date(this.time1);
        let year = d.getFullYear();
        let month = d.getMonth() + 1;
        let day = d.getDate();
        this.time1 = year + '-' + month + '-' + day;
      },
      back(){
        this.$router.replace({path:'/Order'})
      },
      uploadData(msg) {
        this.to_picture= msg
        console.log(this.to_picture)
      },
     updateOrder(){
        // alert(this.to_date)
       if(this.to_state==='未发货'){
         this.to_state=0
       }else if(this.to_state==='已发货'){
         this.to_state=1
       }else if(this.to_state==='已收货'){
         this.to_state=2
       }
        // alert(this.to_state)
        this.$inbound.post({
          interfaceId: 'order/updateOrder',
          data: {
            to_id:this.to_id,
            to_state:this.to_state,
            to_orderNumber: this.to_orderNumber,
            // to_picture:this.to_picture,
            to_remark:this.to_remark,
            to_account:this.to_account,
            to_date:this.to_date,
          }
        }).then(response => {
          this.$router.replace({path:'Order'})
        }).catch(error => {
          console.log(error)
        })
      }
    }
  }
</script>

<style>

</style>
